const firebaseConfig = {
    apiKey: "AIzaSyAEWmgilp_eV0LRxsiJlvsLYOqEkTt2Rlo",
    authDomain: "travel-touch.firebaseapp.com",
    projectId: "travel-touch",
    storageBucket: "travel-touch.appspot.com",
    messagingSenderId: "909888276434",
    appId: "1:909888276434:web:0358f5ce007f7909c7ea0b"
  };

  export default firebaseConfig;